import _ from 'lodash';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {ADD_MSG} from 'common/types';

const mapDispatchToProps = (dispatch) => ({
  navChild: (index) => dispatch(DynamicComponentActions.navChild(index)),
  navParent: () => dispatch(DynamicComponentActions.navParent()),
  navSiblingNext: () => dispatch(DynamicComponentActions.navSiblingNext()),
  navSiblingPrev: () => dispatch(DynamicComponentActions.navSiblingPrev()),
  navToSpecificLocation: (specificLocation) =>
    dispatch(DynamicComponentActions.navToSpecificLocation(specificLocation)),
  saveData: (dataPath, componentData) =>
    dispatch(DynamicComponentActions.saveData(dataPath, componentData)),
  navNext: () => {
    // somewhat arbitrary; allows user to see nav and keep their context, but
    // doesn't force them to scroll past the full header everytime they change sections
    window.scrollTo(0, 100);
    dispatch(DynamicComponentActions.navNext());
  },
  saveDataErrors: (dataPath, errors) =>
    dispatch(DynamicComponentActions.saveDataErrors(dataPath, errors)),
  // saves to the dataPath in dynamicComponent and triggers the entityType's ApiAction
  saveEntityData: (
    dataPath,
    entityType,
    data,
    fieldName,
    extraProps,
    entityTypeReduxPath,
    patchRequest
  ) => {
    dispatch(
      DynamicComponentActions.saveEntityData(
        dataPath,
        entityType,
        data,
        fieldName,
        false,
        extraProps,
        entityTypeReduxPath,
        patchRequest
      )
    );
  },

  setTotalHoldingAmountExceedsFedShare: (dataPath, componentData) =>
    dispatch(
      DynamicComponentActions.setTotalHoldingAmountExceedsFedShare(
        dataPath,
        componentData
      )
    ),

  clearEntityData: (dataPath, entityType, validationId) =>
    dispatch(DynamicComponentActions.clearEntityData(dataPath, entityType, validationId)),
  // same as above, but expects arrays of dataPaths and datas
  saveManyEntityData: (
    dataPaths,
    entityType,
    dataValues,
    fieldName,
    extraProps,
    entityTypeReduxPath
  ) => {
    dispatch(
      DynamicComponentActions.saveEntityData(
        dataPaths,
        entityType,
        dataValues,
        fieldName,
        true,
        extraProps,
        entityTypeReduxPath
      )
    );
  },
  // good for a single session only, doesn't save to dynamo
  saveEntitySessionData: (dataPath, data, fieldName) => {
    dispatch(DynamicComponentActions.saveEntitySessionData(dataPath, data, fieldName));
  },
  saveSectionStatuses: (sectionStatuses) =>
    dispatch(DynamicComponentActions.saveSectionStatuses(sectionStatuses)),
  addMessage: (msg) => dispatch({type: ADD_MSG, msg: msg}),
});

export default mapDispatchToProps;
